import Api from '../utils/api'

export const getMeasurementsService = async (pointId) => {
  try {
    const response = await Api.get(
      `/measurements`,
      { id: pointId }
    )
    return response.data
  } catch (error) {
    return error
  }
}
